import React from 'react';
import { observer } from 'mobx-react';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';

import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom';
import FacebookSdk from 'libraries/facebook/FacebookSdk';
import ZendeskWrapper from 'libraries/zendesk/ZendeskWrapper';

import { getAccountsRoutes } from './routes/accounts';
import { getAffiliatesRoutes } from './routes/affiliates';
import { getAlertsRoutes } from './routes/alerts';
import { getAuthRoutes } from './routes/auth';
import { getBillingRoutes } from './routes/billing';

import { getConsoleRoutes } from './routes/console';
import { getContactsRoutes } from './routes/contacts';
import { getControlRoutes } from './routes/control';
import { getCustomRoutes } from './routes/custom';

import { getDataRoutes } from './routes/data';
import { getEcommerceRoutes } from './routes/ecommerce';
import { getEmailsRoutes } from './routes/emails';
import { getExtensionsRoutes } from './routes/extensions';
import { getResourcesRoutes } from './routes/resources';
import { getPartnersRoutes } from './routes/partners';
import { getSourcesRoutes } from './routes/sources';
import { getUsersRoutes } from './routes/users';
import { getWorkflowsRoutes } from './routes/workflows';
import { checkLogin } from 'routes/Utils';

import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as api from 'api/Console';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as comUtils from 'utils/Common';
import * as configUtils from 'utils/Config';
import * as iconUtils from 'utils/Icon';
import * as urlUtils from 'utils/Url';
import { setupSentry } from 'Sentry';
import './styles.scss';


const NoAccountsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/auth/no-accounts" */
    'routes/Auth/NoAccountsRoute'
    )
));


const HomeRoute = checkLogin(observer((props) => {
  let product = auth.getCurrentProduct();
  if (!product) product = consoleStore.defaultProduct;

  let url = paths.getProductHome(product);
  if (!url) url = paths.getPathProvisionProduct();

  return <Redirect to={url} />;
}))


// Note:
// React.Suspense are only supported in React Router V6, we are currently using V5.
@observer
class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setupSentry();
    iconUtils.loadIcon(constants.BP_SVG_ICONS_URL);
    iconUtils.loadIcon(constants.FA_SVG_ICONS_URL);
    iconUtils.loadIcon(constants.BOX_SVG_ICONS_URL);
  }

  unpack = (rows) => {
    return rows.map((row) => {
      return (
        <Route
          exact
          key={row.path}
          {...row}
        />
      )
    });
  };

  render() {
      return (
          <Router>
            <FacebookSdk />
            <ZendeskWrapper />
              <div>
                <Switch>
                  <Route exact path={paths.getPathHome()} component={HomeRoute} />
                  {this.unpack(getAccountsRoutes())}
                  {this.unpack(getAffiliatesRoutes())}
                  {this.unpack(getAuthRoutes())}
                  {this.unpack(getAlertsRoutes())}
                  {this.unpack(getBillingRoutes())}

                  {this.unpack(getConsoleRoutes())}
                  {this.unpack(getContactsRoutes())}
                  {this.unpack(getCustomRoutes())}

                  {this.unpack(getDataRoutes())}
                  {this.unpack(getEcommerceRoutes())}
                  {this.unpack(getEmailsRoutes())}
                  {this.unpack(getExtensionsRoutes())}

                  {this.unpack(getResourcesRoutes())}
                  {this.unpack(getPartnersRoutes())}
                  {this.unpack(getSourcesRoutes())}
                  {this.unpack(getUsersRoutes())}
                  {this.unpack(getWorkflowsRoutes())}

                  {this.unpack(getControlRoutes())}
                  <Route component={HomeRoute} />
                </Switch>
              </div>
          </Router>
      )
  }
}




export default App;
